import { createContext } from 'react'
import { LoggedInUser } from 'shared/types/user'

export type UserContextProps = {
    user: LoggedInUser
    isLoggedIn: boolean
}

const UserContext = createContext({} as UserContextProps)

export default UserContext
